import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 이용약관 (Terms of Service)
 * Customer-facing terms for QR order platform.
 */
export default function TermsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page" style={{ background: 'var(--bg)', paddingBottom: 'calc(40px + var(--safe-bottom))' }}>
      <header
        className="page-header"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'var(--surface)',
          borderBottom: '1px solid var(--border)',
          padding: 'calc(var(--safe-top) + 14px) 20px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          minHeight: 56,
        }}
      >
        <button
          className="back-btn"
          onClick={() => navigate(-1)}
          aria-label="뒤로 가기"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="page-header-title">이용약관</div>
        <div style={{ width: 36 }} />
      </header>

      <main style={{ padding: '24px 20px 40px', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 8 }}>
            서비스 이용약관
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>
            최종 개정일: 2026년 1월 1일 · 시행일: 2026년 1월 1일
          </p>
        </div>

        <Section title="제1조 (목적)">
          <p>
            본 약관은 스마트오더(이하 "회사")가 제공하는 QR 코드 기반 주문 및 결제 서비스(이하 "서비스")의 이용과
            관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 이용조건 및 절차, 기타 필요한 사항을 규정함을
            목적으로 합니다.
          </p>
        </Section>

        <Section title="제2조 (정의)">
          <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
          <ol className="terms-list">
            <li>"서비스"란 이용자가 매장 내 테이블에 비치된 QR 코드를 스캔하여 메뉴 조회, 주문, 결제, 직원 호출 등의 기능을 이용할 수 있도록 회사가 제공하는 일체의 서비스를 말합니다.</li>
            <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 고객을 말합니다.</li>
            <li>"매장"이란 회사와 가맹 계약을 체결하고 서비스를 통해 상품 또는 용역을 판매하는 음식점 등 사업자를 말합니다.</li>
            <li>"주문"이란 이용자가 서비스를 통하여 매장의 상품을 선택하고 결제 의사를 표시하는 행위를 말합니다.</li>
            <li>"결제"란 이용자가 주문한 상품 또는 용역의 대가를 지급하는 행위를 말하며, 신용카드, 간편결제, 계좌이체 등 회사가 정한 방법으로 이루어집니다.</li>
          </ol>
        </Section>

        <Section title="제3조 (약관의 효력 및 변경)">
          <ol className="terms-list">
            <li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
            <li>회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 약관을 개정할 경우 적용일자 및 개정사유를 명시하여 현행 약관과 함께 적용일자 7일 이전부터 공지합니다. 다만 이용자에게 불리하게 약관을 변경하는 경우에는 최소 30일 이상의 사전 유예기간을 두고 공지합니다.</li>
            <li>회사가 전항에 따라 개정약관을 공지하면서 이용자에게 적용일자 전까지 거부 의사를 표명하지 않으면 동의한 것으로 본다는 뜻을 명확하게 공지하였음에도 이용자가 명시적으로 거부 의사를 표시하지 아니한 경우 개정약관에 동의한 것으로 봅니다.</li>
          </ol>
        </Section>

        <Section title="제4조 (서비스 내용)">
          <p>회사가 제공하는 서비스는 다음과 같습니다.</p>
          <ol className="terms-list">
            <li>매장 메뉴 조회 및 검색 서비스</li>
            <li>QR 코드 스캔을 통한 테이블 주문 서비스</li>
            <li>주문 상태 실시간 확인 서비스</li>
            <li>신용카드, 간편결제 등을 통한 결제 서비스</li>
            <li>직원 호출 및 요청 전달 서비스</li>
            <li>전자 영수증 발행 서비스</li>
            <li>기타 회사가 추가 개발하거나 다른 사업자와의 제휴를 통해 이용자에게 제공하는 일체의 서비스</li>
          </ol>
          <p style={{ marginTop: 8 }}>
            회사는 서비스의 내용, 이용 방법, 이용 시간에 대하여 변경이 있는 경우에는 변경사유, 변경 내용 및 제공 일자
            등을 그 변경 전 7일 이상 해당 서비스 초기 화면에 게시하여야 합니다.
          </p>
        </Section>

        <Section title="제5조 (이용자 의무)">
          <p>이용자는 다음 각 호의 행위를 하여서는 아니 됩니다.</p>
          <ol className="terms-list">
            <li>타인의 정보를 도용하거나 허위 정보를 입력하는 행위</li>
            <li>회사가 게시한 정보를 무단으로 변경하는 행위</li>
            <li>회사 및 기타 제3자의 저작권 등 지적재산권을 침해하는 행위</li>
            <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li>외설 또는 폭력적인 메시지, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
            <li>재화 등의 구매 의사 없이 반복적으로 주문을 취소하거나 결제 후 부당하게 환불을 요구하는 행위</li>
            <li>기타 관계 법령에 위배되는 행위</li>
          </ol>
        </Section>

        <Section title="제6조 (결제 및 환불)">
          <ol className="terms-list">
            <li>이용자는 서비스가 제공하는 결제 수단을 통하여 주문한 상품 또는 용역의 대금을 지급하여야 합니다.</li>
            <li>결제 수단에는 신용카드, 체크카드, 카카오페이, 토스페이, 계좌이체 등이 포함되며, 회사의 사정에 따라 추가되거나 제한될 수 있습니다.</li>
            <li>결제 대행은 전자금융거래법에 따라 등록된 전자지급결제대행업자를 통해 이루어지며, 결제 정보는 해당 대행사의 보안 시스템을 통해 안전하게 처리됩니다.</li>
            <li>이용자는 매장이 주문을 수락한 이후에는 원칙적으로 주문을 취소할 수 없습니다. 다만, 조리가 시작되기 전이거나 매장의 사정으로 주문을 이행할 수 없는 경우에는 전액 환불이 가능합니다.</li>
            <li>환불은 결제 수단과 동일한 경로로 이루어지며, 카드 결제의 경우 카드사 정책에 따라 3일에서 7일의 기간이 소요될 수 있습니다.</li>
            <li>기타 환불에 관한 상세한 사항은 환불정책을 따릅니다.</li>
          </ol>
        </Section>

        <Section title="제7조 (개인정보보호)">
          <ol className="terms-list">
            <li>회사는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.</li>
            <li>회사는 이용자의 개인정보를 보호하기 위하여 개인정보보호법 등 관련 법령에 따라 필요한 조치를 취하며, 개인정보 처리에 관한 자세한 사항은 별도의 개인정보처리방침에서 정합니다.</li>
            <li>이용자는 언제든지 자신의 개인정보를 조회, 수정, 삭제하거나 처리 정지를 요청할 수 있습니다.</li>
          </ol>
        </Section>

        <Section title="제8조 (책임의 한계)">
          <ol className="terms-list">
            <li>회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지, 정전 등 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
            <li>회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</li>
            <li>회사는 이용자가 서비스를 통하여 매장에 주문한 상품의 품질, 안전성 등에 대하여는 매장이 일차적인 책임을 지며, 회사는 통신판매중개자 또는 단순 플랫폼 제공자로서 그 책임 범위가 제한됩니다.</li>
            <li>회사는 이용자 상호간 또는 이용자와 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</li>
          </ol>
        </Section>

        <Section title="제9조 (분쟁 해결)">
          <ol className="terms-list">
            <li>회사와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.</li>
            <li>회사와 이용자 간에 제기된 소송에는 대한민국 법을 적용합니다.</li>
            <li>이용자는 한국소비자원, 전자거래분쟁조정위원회 등 관계 기관을 통하여 분쟁 해결을 신청할 수 있습니다.</li>
          </ol>
        </Section>

        <Section title="부칙">
          <ol className="terms-list">
            <li>본 약관은 2026년 1월 1일부터 시행합니다.</li>
            <li>본 약관 시행 이전 가입한 이용자에게도 본 약관이 적용됩니다.</li>
          </ol>
          <p style={{ marginTop: 12, fontSize: 13, color: 'var(--text-tertiary)' }}>
            본 약관에 관한 문의사항은 고객지원 페이지 또는 고객센터를 통해 접수하여 주시기 바랍니다.
          </p>
        </Section>
      </main>

      <style>{`
        .terms-list {
          padding-left: 20px;
          margin-top: 8px;
        }
        .terms-list li {
          font-size: 14px;
          color: var(--text-secondary);
          line-height: 1.75;
          margin-bottom: 6px;
        }
      `}</style>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: 'var(--text)',
          marginBottom: 10,
          letterSpacing: '-0.3px',
        }}
      >
        {title}
      </h2>
      <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.75 }}>
        {children}
      </div>
    </section>
  );
}
